import { sellerCustomerCareAPI } from '@backmarket/http-api'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

export function useFormattedQueryParams(filters: sellerCustomerCareAPI.Filter) {
  const nonEmptyQueryParams = Object.entries(filters).reduce(
    (nonEmptyFilters, [filterName, value]) => {
      if (isEmpty(value)) {
        return nonEmptyFilters
      }
      if (Array.isArray(value)) {
        const formattedMultiselectValues = value.join(',')

        return {
          ...nonEmptyFilters,
          [filterName]: formattedMultiselectValues,
        }
      }

      return {
        ...nonEmptyFilters,
        [filterName]: value,
      }
    },
    {},
  )

  return nonEmptyQueryParams
}
